import React, { Component } from 'react';
import { TextInput, Loading, FormGroup, FormLabel, Button, DatePickerSkeleton } from 'carbon-components-react';
import '../../scss/custom.scss';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getError,
  getSuccess,
  entitiesLabels,
  apioperation,
  STATUS,
  DateFormat,
} from '../../helpers/Constants';
import { api } from '../../helpers/api/api';
import CAList from './CAList';
import { IsEditable, CanExecuteAction } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { CheckmarkOutline16, Send16, Delete16, Error16 } from '@carbon/icons-react/lib/';
import { WFActionModal } from '../common/WFActionModal';
import { ChevronLeft16, Information16 } from '@carbon/icons-react';
import { HistoryTable } from '../../helpers/HistoryTable';
import { Online, Offline } from '../common/OnLineOffLine';
import DateTimePicker from '../../helpers/DateTimePicker';

import { v4 as uuid } from "uuid";
import AttachmentTable from '../common/AttachmentTable';


export default class CARDetail extends Component {
  baseUrl;

  constructor(props) {
    super(props);
    let idIncidentEdit = props ? props.match.params.id : '';
    let idCar = props ? props.match.params.idCar : '';

    this.state = {
      idIncidentEdit: idIncidentEdit,
      idCar: idCar,
      isLoading: true,
      model: null,
      keyCAList: `listCA_${new Date().getTime()}`,
      ///Status Action
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      ///Status Action
      isHistoryModalOpen: false,
    };
    this.baseUrl = '/incident/' + idIncidentEdit + '/car/';
  }

  componentDidMount() {
    this.getCAR();
  }
  showButtonHistory = () => {
    return (
      <Online>
        <Button
          className="action-button-modal"
          kind="secondary"
          renderIcon={Information16}
          onClick={() => this.openModalHistory()}
        >
          History
        </Button>
      </Online>
    );
  };
  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };
  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };
  handleChangePaging = async (page) => {
    await new Promise((resolve) => {
      this.setState(
        { currentPage: page.page, pageSize: page.pageSize, loading: true, isBack: false },
        resolve
      );
    });
    this.getCAR();
  };
  getCAR = () => {
    this.setState({
      isLoading: true,
    });

    let id = this.state.idCar;
    let filter = {
      params: {
        page: this.state.currentPage,
        pageSize: this.state.pageSize,
      },
    };
    api
      .getWithParam(this.baseUrl + id, filter)
      .then((response) => {
        let data = response.data;
        if (data) {
          this.setState({
            model: data.result,
            listCas: data ? data.resultCas : [],
          });
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`, 'CAR not found');
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CAR, apioperation.GET)
        );
        this.props.history.push(this.baseUrl);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  showLoading() {
    let show = this.state.isLoading || this.state.isSubmitted;
    let descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active={true} withOverlay={true} description={descr} />;
    //return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    let action = this.state.approvalModalAction.toLowerCase();
    let apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.idCar],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(this.baseUrl + apiEndpoint, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            `${entitiesLabels.INCIDENT} ${entitiesLabels.CAR} ${
              entitiesLabels.WITHCODE
            } ${getSuccess(this.state.model.incidentCARCode, apioperation.PUT)}`
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            isLoading: true,
            // model: null
          });
          if (apiEndpoint == 'Delete') {
            this.props.history.push(this.baseUrl);
          } else {
            this.getCAR();
          }
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CAR, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  IsRowSelectable() {
    var row = this.state.model;
    if (row == null) return false;

    return true;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    this.setState({
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover: withApprover,
      selectedData: selectedRows,
      approverRole: approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired: approvalNotesRequired,
    });
  }

  canApproveCAR = () => {
    let item = this.state.model;
    return item && item.ca && item.ca.length > 0;
  };

  canCloseCAR = () => {
    let item = this.state.model;
    return item && item.ca && item.ca.length > 0
      ? item.ca.filter((el) => el.idStatus == 4).length == item.ca.length
      : false;
  };

  getStatusActions = (user, canEditResource) => {
    if (!this.IsRowSelectable()) return null;

    const idStatus = this.state.model.idStatus;
    return (
      <Online>
        {/* {this.canApproveCAR() &&
        CanExecuteAction('Incident', 'CARManagement', user, idStatus, 'Submit', canEditResource) ? (
          <Button
            renderIcon={Send16}
            onClick={() => this.batchActionClick('Submit', 'Submit', null, false, false, null)}
          >
            Submit CAR
          </Button>
        ) : null} */}

        {this.canApproveCAR() &&
        CanExecuteAction(
          'Incident',
          'CARManagement',
          user,
          idStatus,
          'Approve',
          canEditResource
        ) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() => this.batchActionClick('Approve', 'Approve', null, false, false, null)}
          >
            Approve CAR
          </Button>
        ) : null}

        {this.canCloseCAR() &&
        CanExecuteAction(
          'Incident',
          'CARManagement',
          user,
          idStatus,
          'Consolidate',
          canEditResource
        ) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() => this.batchActionClick('Close', 'Close', null, false, false, null)}
          >
            Close CAR
          </Button>
        ) : null}

        {CanExecuteAction('Incident', 'CARManagement', user, idStatus, 'Open', canEditResource) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() => this.batchActionClick('Open', 'Open', null, false, false, null)}
          >
            Open CAR
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'CARManagement',
          user,
          idStatus,
          'Reject',
          canEditResource
        ) ? (
          <Button
            renderIcon={Error16}
            onClick={() => this.batchActionClick('Reject', 'Reject', null, false, true, null)}
          >
            Reject CAR
          </Button>
        ) : null}

        {CanExecuteAction(
          'Incident',
          'CARManagement',
          user,
          idStatus,
          'Delete',
          canEditResource
        ) ? (
          <Button
            renderIcon={Delete16}
            onClick={() => this.batchActionClick('Delete', 'Delete', null, false, false, null)}
          >
            Delete CAR
          </Button>
        ) : null}
      </Online>
    );
  };

  updateActualCompletion = (_, value) => this.setState({model: {...this.state.model, actualDateCompletition: value}})
  
  clearAttachment = () => ({
		id: null, // guid
		fileIdentifier: null,
		name: null,
		contentType: null,
		size: null,
		type: null,
	});

  onUploadFiles = (fileIdentifier, fileName, fileType, size) => {
    const attachment = { ...this.state.attachment };

    attachment.id = uuid();
    attachment.fileIdentifier = fileIdentifier.blobName;
    attachment.name = fileName;
    attachment.contentType = fileType;
    attachment.size = size;
    // attachment.filePath = file.localPath;

    this.setState({
      attachment: this.clearAttachment(),
    });

    try {
      if (attachment == null) return;
      // insert
      const oldattachment = this.state.model.attachment || [];

      const newItem = {
        id: uuid(), // guid

        idAttachment: attachment.id, // guid
        attachment,
      };

      const newattachment = oldattachment.concat([newItem]);
      this.setState({model: {...this.state.model, attachment: newattachment}})
    } catch (error) {
      showNotification.error();
    }
  };

  onRemoveFile = (id) => {
    if (!id) return;
    const statusCopy = { ...this.state.model };
    statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);
    this.setState({model: statusCopy});
  };

  save = () => {
        const { model } = this.state;

        // model.directCauseSubCategory = this.state.appDirectCauseSubCategory.find(el => el.id == model.idDirectCauseSubCategory);
        model.directCauseSubCategory = model.idDirectCauseSubCategory;
        // model.rootCauseSubCategory = this.state.appRootCauseSubCategory.find(el => el.id == model.idRootCauseSubCategory);
        model.rootCauseSubCategory = model.idRootCauseSubCategory
        model.closedOn= null;
        
        model.id = this.state.idCar

        this.setState({
          isSubmitted: true,
        });

        let idincident = this.props ? this.props.match.params.id : ''
        const method = api.put('/incident/' + idincident + '/cardto/', model, model.id);
    
        method
          .then((response) => {
            if (response.status == 200) {
              showNotification.success(`${entitiesLabels.SUCCESS}`,`${entitiesLabels.INCIDENT} ${entitiesLabels.CAR} ${getSuccess(response.data.incidentCARCode,apioperation.PUT)}`);
            } else {
              showNotification.error();
            }
          })
          .catch((error) => {
            showNotification.error(`${entitiesLabels.ERROR}`, getError(error,entitiesLabels.CAR, apioperation.PUT));
          })
          .finally(() => {
            this.setState({
              isSubmitted: false,
            });
          });

      this.forceUpdate();
    }




  render() {
    const incidentCA = this.state.model
      ? this.state.model.ca.filter((x) => this.state.listCas?.itemList.some((y) => y.id == x.id))
      : null;

    const CAListProps = {
      key: this.state.keyCAList,
      idIncidentEdit: this.state.idIncidentEdit,
      isLoading: this.state.isLoading,
      idCar: this.state.idCar,
      incidentCA: incidentCA,
      history: this.props.history,
      match: this.props.match,
      car: this.state.model?.dueDate,
      statusCar: this.state.model?.idStatus,
      statusIncident: this.state.model?.incident?.idStatus,
      listCa: this.state.listCas,
      currentPage: this.state.listCas?.currentPage || 1,
      pageSize: this.state.listCas?.pageSize || 10,
      rowCount: this.state.listCas?.rowCount || 0,
      getCAs: this.getCAR,
      handleChangePaging: this.handleChangePaging,
    };

    const canEditResource = this.state.model && {
      idCompiler: this.state.model.incident.idCompiler,
      idDataApprover: this.state.model.incident.idDataApprover,
      idDivisionManager: this.state.model.incident.idDivisionManager,
      email:
        this.state.model.owner != null
          ? this.state.model.owner.email
          : this.state.model.ownerSaipem != null
          ? this.state.model.ownerSaipem.email
          : '',
    };

    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={'/incident/' + this.state.idIncidentEdit + '/car/'}
              linkText="CAR List"
              titleLeft={
                'Incident Id: ' +
                ((this.state.model && this.state.model.incidentCode) || '') +
                ' - CAR Detail'
              }
              titleCenter={this.state.model && 'ID: ' + this.state.model.incidentCARCode}
              titleRight={
                this.state.model && this.state.model.status
                  ? this.state.model.status.carManagementName
                  : null
              }
              batchActions={this.getStatusActions(user, canEditResource)}
              showButtonHistory={this.showButtonHistory()}
            />
            <div className="mainContainer">
              {this.showLoading()}
              <WFActionModal
                show={this.state.isApprovalModalOpen}
                title={`${this.state.approvalModalAction} Incident CARs`}
                action={this.state.approvalModalAction}
                withApprover={this.state.withApprover}
                approver={this.state.approver}
                approverRole={this.state.approverRole}
                approverOptions={this.state.approvers}
                isLoadingOperation={this.state.isLoadingWFOperation}
                onApproverSelect={this.handleApproverSelect}
                isLoadingOptions={this.state.isLoadingApproverOptions}
                onCancel={this.handleCloseApprovalModal}
                onConfirm={this.handleConfirmApprovalModal}
                onApprovalNotesChange={this.handleApprovalNotesChange}
                approvalNotes={this.state.approvalNotes}
                approvalNotesRequired={this.state.approvalNotesRequired}
                validationMessages={this.state.approvalValidationMessages}
              />
              {
                <HistoryTable
                  entityId={this.state.idCar}
                  isOpenModal={this.state.isHistoryModalOpen}
                  onClose={() => this.closeModalHistory()}
                />
              }
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  {this.state.model && (
                    <div className="bx--row">
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Due Date">
                          <TextInput
                            id="dueDate1"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={switchDateFormat(this.state.model.dueDate, 'date')}
                            disabled={true}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Status">
                          <TextInput
                            id="status"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={
                              this.state.model.status && this.state.model.status.carManagementName
                            }
                            disabled={true}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Direct Cause Category">
                          <TextInput
                            id="dr1"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={this.state.model.directCause}
                            disabled={true}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Direct Cause Sub-Category">
                          <TextInput
                            id="dr2"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={this.state.model.directCauseSubCategory}
                            disabled={true}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Root Cause Category">
                          <TextInput
                            id="rc1"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={this.state.model.rootCause}
                            disabled={true}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Root Cause Sub-Category">
                          <TextInput
                            id="r2"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={this.state.model.rootCauseSubCategory}
                            disabled={true}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-6">
                        <FormGroup legendText="Root Cause Sub-Category Detail">
                          <TextInput
                            id="r3"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={this.state.model.rootCauseSubCategoryDetail}
                            disabled={true}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-4 bx--col-lg-4">
                        <FormGroup legendText="CAR Owner">
                          <TextInput
                            id="txt-name"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={
                              this.state.model.owner
                                ? this.state.model.owner.name + ' ' + this.state.model.owner.surname
                                : `${this.state.model.ownerSaipem.name} ${this.state.model.ownerSaipem.surname}`
                            }
                            disabled={true}
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-3 bx--col-lg-2">
                        <FormGroup legendText="CAR Owner Involved">
                          <TextInput
                            id="txt-name"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={this.state.model.incident.idStatus > 2 ? 'Yes' : 'No'}
                            disabled={true}
                          />
                        </FormGroup>
                      </div>

                      <div className="bx--col-md-6 bx--col-lg-6">
                        <FormGroup legendText="Actual date of completion of CAR">
                          {!this.state.model ? (
                            <DatePickerSkeleton />
                          ) : (
                            <DateTimePicker
                              value={this.state.model?.actualDateCompletition}
                              type="date"
                              disableFutureDate
                              placeholder={DateFormat}
                              name="actualDateCompletition"
                              alt="actualDateCompletition"
                              // invalid={validations.occurredAt != null}
                              onChange={this.updateActualCompletion}
                              disabled

                            
                            />
                        )}
                        </FormGroup>
                      </div>

                    </div>
                  )}

            <AttachmentTable
                storagePath="incident"
                model={this.state.model}
                items={this.state.model?.attachment}
                // apiDownloadUrl={`/incident/${this.state.idIncident}/car/${this.props?.editModel?.id}/attachment/`}
                apiDownloadUrl={`/incident/${this.state.model?.incident.id}/car/${this.state.model?.id}/attachment/`}
                onUploadFIle={this.onUploadFiles}
                onDeleteFile={this.onRemoveFile}
                isDisabled={!IsEditable(
                  'Incident',
                  'CARManagement',
                  user,
                  this.state.model?.idStatus ?? null,
                  'Attachments',
                  canEditResource
                )}
              />

                     {IsEditable('Incident','CARManagement', user, this.state.model?.idStatus ?? null, 'Attachments', canEditResource) ? (
                      <div className="bx--row" style={{width:"100%", display:"flex", justifyContent:"flex-end", flexWrap:"nowrap", marginBottom:"50px"}}>
                        <Button style={{width:"100%"}} kind="primary" onClick={() => this.save()}> Save</Button>
                      </div>
                    ) : null}


                  <div className="bx--row">
                    <div className="bx--col-lg-12">
                      <CAList
                        {...CAListProps}
                        isDisabled={
                          !IsEditable(
                            'Incident',
                            'CARManagement',
                            user,
                            this.state.model ? this.state.model.idStatus : null,
                            'CA',
                            canEditResource
                          ) /*|| this.state.model?.idStatus == 1 */
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
